import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-2GNCTHTX37";
const GTAG_POLL_MS = 100;
const GTAG_MAX_WAIT_MS = 10000;

function waitForGtag() {
  return new Promise((resolve) => {
    if (typeof window.gtag === "function") {
      resolve(window.gtag);
      return;
    }

    const started = Date.now();
    const interval = setInterval(() => {
      if (typeof window.gtag === "function") {
        clearInterval(interval);
        resolve(window.gtag);
      } else if (Date.now() - started >= GTAG_MAX_WAIT_MS) {
        clearInterval(interval);
        resolve(null);
      }
    }, GTAG_POLL_MS);
  });
}

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      lastTrackedPath.current = pagePath;
      return;
    }

    if (lastTrackedPath.current === pagePath) return;

    let cancelled = false;

    (async () => {
      const gtag = await waitForGtag();
      if (cancelled || !gtag || lastTrackedPath.current === pagePath) return;

      lastTrackedPath.current = pagePath;
      gtag("config", GA_MEASUREMENT_ID, {
        page_path: pagePath,
        page_title: document.title,
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
